import validate from "/home/runner/work/mfx-framework/mfx-framework/node_modules/.pnpm/nuxt@3.4.3_@types+node@18.16.12_eslint@8.40.0_typescript@4.9.5/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}